import { render, staticRenderFns } from "./RoomGridItem.vue?vue&type=template&id=58d77c50&"
import script from "./RoomGridItem.vue?vue&type=script&lang=js&"
export * from "./RoomGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports